<div class="legal-page">

    <!-- HERO -->
    <section class="legal-hero">
        <div class="legal-container">

            <div class="legal-eyebrow">SPEKWO, LLC · LEGAL</div>

            <h1>Privacy Policy</h1>

            <p class="legal-date">LAST UPDATED: 09/12/2024</p>

            <div class="legal-divider"></div>

            <p class="legal-intro">
                Welcome to speKwo.com ("we," "us," or "our"). We are committed to protecting your personal
                information and your right to privacy. This Privacy Policy describes how we collect, use, and
                safeguard your information when you visit our website and use our contact form or opt-in to
                receive text messages, emails, or phone communication from our office.
            </p>

            <p class="legal-intro">
                By using our website, you agree to the collection and use of information in accordance with this policy.
            </p>

            <!-- 01 -->
            <h2 class="legal-section-heading">
                <span class="section-num">01</span>
                <span>Information We Collect</span>
            </h2>

            <p class="legal-body">
                <strong>Personal Information.</strong> When you use our contact form or opt-in to receive text
                messages, we may collect the following personal information:
            </p>

            <ul class="legal-list">
                <li>Name</li>
                <li>Email Address</li>
                <li>Phone Number</li>
            </ul>

            <p class="legal-body">
                <strong>Automatically Collected Information.</strong> We may also collect certain information
                automatically when you visit our website, such as your IP address, browser type, and pages
                visited. This information is used for analytical purposes to improve our website's functionality.
            </p>

            <!-- 02 -->
            <h2 class="legal-section-heading">
                <span class="section-num">02</span>
                <span>How We Use Your Information</span>
            </h2>

            <p class="legal-body">We use the information we collect for the following purposes:</p>

            <ul class="legal-list">
                <li>
                    <strong>To Respond to Inquiries:</strong> We use your contact information to respond to
                    questions, comments, or requests submitted via our contact form.
                </li>
                <li>
                    <strong>Text Messaging:</strong> If you opt-in, we will use your phone number to send you
                    text messages regarding the request you made on our site, our services, updates, or
                    promotional offers.
                </li>
            </ul>

            <!-- 03 -->
            <h2 class="legal-section-heading">
                <span class="section-num">03</span>
                <span>Sharing Your Information</span>
            </h2>

            <p class="legal-body">
                We do not sell, trade, rent, or share your personal information with third parties. We do not
                share your information with any third-party service providers for any purpose.
            </p>

            <p class="legal-body">
                Your personal information is used exclusively by speKwo.com to provide and improve our services,
                ensuring your privacy is maintained.
            </p>

            <p class="legal-body">
                SMS consent and phone numbers collected/captured for SMS purposes will not be shared, sold, or
                disclosed with any third parties, or any other individual for any type of marketing purposes, or
                affiliate marketing.
            </p>

            <!-- 04 -->
            <h2 class="legal-section-heading">
                <span class="section-num">04</span>
                <span>Cookies and Tracking Technologies</span>
            </h2>

            <p class="legal-body">
                Our website may use "cookies" to enhance user experience. You can choose to set your web browser
                to refuse cookies or to alert you when cookies are being sent. Note that some parts of the site
                may not function properly if cookies are disabled.
            </p>

            <!-- 05 -->
            <h2 class="legal-section-heading">
                <span class="section-num">05</span>
                <span>Data Security</span>
            </h2>

            <p class="legal-body">
                We implement reasonable security measures to protect your personal information from unauthorized
                access, alteration, disclosure, or destruction. However, no method of transmission over the
                internet or electronic storage is 100% secure.
            </p>

            <!-- 06 -->
            <h2 class="legal-section-heading">
                <span class="section-num">06</span>
                <span>Your Choices and Rights</span>
            </h2>

            <ul class="legal-list">
                <li>
                    <strong>Opt-Out:</strong> You may opt-out of receiving text messages or emails from us at
                    any time by following the unsubscribe instructions provided in the communication or by
                    contacting us directly.
                </li>
                <li>
                    <strong>Access and Correction:</strong> You have the right to access and correct your
                    personal information. Contact us to make any changes.
                </li>
            </ul>

            <!-- 07 -->
            <h2 class="legal-section-heading">
                <span class="section-num">07</span>
                <span>Third-Party Links</span>
            </h2>

            <p class="legal-body">
                Our website may contain links to third-party websites. We are not responsible for the privacy
                practices of these external sites. We encourage you to read the privacy policies of any linked
                websites you visit.
            </p>

            <!-- 08 -->
            <h2 class="legal-section-heading">
                <span class="section-num">08</span>
                <span>Changes to This Privacy Policy</span>
            </h2>

            <p class="legal-body">
                We reserve the right to update or change our Privacy Policy at any time. Any changes will be
                posted on this page with an updated revision date.
            </p>

            <!-- 09 -->
            <h2 class="legal-section-heading">
                <span class="section-num">09</span>
                <span>Contact Us</span>
            </h2>

            <p class="legal-body">
                If you have any questions about this Privacy Policy or our data practices, please contact us:
                <strong>Email:</strong> <a href="mailto:info@spekwo.com">Info&#64;spekwo.com</a> ·
                <strong>Phone:</strong> 704-626-1776 ·
                <strong>Address:</strong> 19701 Bethel Church Road, Suite 103-119, Cornelius, NC 28031
            </p>

            <p class="legal-body">
                By providing a clear and concise Privacy Policy, we aim to build trust with our users and ensure
                transparency in how we handle personal information.
            </p>

            <!-- CONTACT CARD -->
            <div class="legal-contact-card">
                <div class="contact-card-label">QUESTIONS?</div>
                <p>
                    Contact speKwo at
                    <a href="mailto:info@spekwo.com"><strong>info&#64;spekwo.com</strong></a>
                    or call
                    <a href="tel:7046261776"><strong>704-626-1776</strong></a>
                    · 19701 Bethel Church Road, Suite 103-119, Cornelius, NC 28031
                </p>
            </div>

        </div>
    </section>

</div>